import * as Type from './types'

import { executeCallback, setInMemory } from '@services/store/utils'

const initialState = {
    data: {},
    formated: {},
    loaded: null
}

export default function LandingZoneTeamsReducer(state = initialState, action) {
    if (action.type === Type.POPULATE) {
        return executeCallback(
            setInMemory(state, action, 'data'),
            action,
            'landingZoneTeams'
        )
    }
    else if (action.type === Type.SET_FORMAT) {
        return executeCallback(
            setInMemory(state, action, 'formated'),
            action,
            'landingZoneTeams'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded'),
            action,
            'landingZoneTeams'
        )
    }

    return state
}
